export const SCREEN_SIZES = {
  MOBILE: 480,
  TABLET: 768,
  SMALL_DESKTOP: 1024,
  DESKTOP: 1280,
  LARGE_DESKTOP: 1536,
};

export const LAYOUT_12COL = 12;

export const BUTTON_STYLE = {
  Primary: "Primary",
  Secondary: "Secondary",
};